export { LandingPageHero } from '@/components/common/LandingPageHero/LandingPageHero';
